const angular = require('angular');
const app = angular.module('learn-services');

/**
 * Builds a quoted CSS url() for ng-style from an image URL in stored data (avatars, profile
 * banners). Those fields are stored unvalidated, so the URL is escaped for a CSS string, and
 * anything that isn't http(s) or a relative path gives '' (no image).
 */
app.factory('cssUrl', [function() {
  var allowed = /^(https?:|\/|[^:/?#]*([/?#]|$))/i;
  return function(value) {
    var url = String(value == null ? '' : value).trim();
    if (!url || !allowed.test(url)) {
      return '';
    }
    return 'url("' + url.replace(/["\\\n\r\f]/g, function(character) {
      return '\\' + character.charCodeAt(0).toString(16) + ' ';
    }) + '")';
  };
}]);
